const JP_Data = [
    {
        children: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464726/white.png',
                productId: '14718195564911',
                variantId: '52003665576303',
                color: '#e2e2df',
                name: 'white',
                rHref: 'https://www.amazon.co.jp/dp/B0FCY8H457',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463061/black.png',
                productId: '14718195564911',
                variantId: '52003665510767',
                // rHref: 'https://www.amazon.co.jp/dp/B0FCY39MTC',
                name: 'black',
                lDisabled: true,
                color: '#212121',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463425/blue.png',
                productId: '14718195564911',
                variantId: '52003665609071',
                name: 'purple',
                lDisabled: true,
                color: '#b5b2e3',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463865/green.png',
                productId: '14718195564911',
                variantId: '52003665543535',
                lDisabled: true,
                name: 'green',
                color: '#a6cba1',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464318/pink.png',
                productId: '14718195564911',
                variantId: '52003679601007',
                lDisabled: true,
                color: '#f3caa8',
            },
        ],
        rHref: '',
    },
    {
        children: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464925/white2.png',
                productId: '14718204379503',
                variantId: '52003754574191',
                color: '#e2e2df',
                name: 'white',
                rHref: 'https://www.amazon.co.jp/dp/B0FCWXHDY5',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463227/black2.png',
                productId: '14718204379503',
                variantId: '52003754541423',
                lDisabled: true,
                color: '#212121',
                name: 'black',
                // rHref: 'https://www.amazon.co.jp/dp/B0FCXC7RKH',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463617/blue2.png',
                productId: '14718204379503',
                variantId: '52003754606959',
                lDisabled: true,
                color: '#b5b2e3',
                name: 'purple',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464088/green2.png',
                productId: '14718204379503',
                variantId: '52003754639727',
                lDisabled: true,
                color: '#a6cba1',
                name: 'green',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464555/pink2.png',
                productId: '14718204379503',
                variantId: '52003754672495',
                lDisabled: true,
                color: '#f3caa8',
                name: 'pink',
            },
        ],
        rHref: '',
    },
    {
        children: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748679704700/1.png',
                color: '#cdcdcd',
                productId: '14630813466991',
                variantId: '51675869249903',
                name: 'silver',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573309/50-blue.png',
                color: '#c0defe',
                productId: '14630813466991',
                variantId: '51675870331247',
                name: 'blue',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573021/50-black.png',
                color: '#212121',
                productId: '14630813466991',
                variantId: '51675870364015',
                name: 'black',
            },
        ],
        rHref: '',
    },
    {
        children: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1748679704863/2.png',
                color: '#cdcdcd',
                productId: '14631171883375',
                variantId: '51670335750511',
                name: 'silver',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573544/100-black.png',
                color: '#212121',
                productId: '14631171883375',
                variantId: '51670335816047',
                name: 'black',
            },
        ],
        rHref: '',
    },
];

const getEuData = (locale = 'eu') => {
    const productId1 = {
        eu: '10057130049879',
        uk: '9922548629843',
        de: '15246676164989',
        fr: '9916300656987',
        it: '14929760649592',
        es: '9916312224091',
    }[locale];
    const productId2 = {
        eu: '10057130639703',
        uk: '9922552103251',
        de: '15246676590973',
        fr: '9916300820827',
        it: '14929760682360',
        es: '9916312355163',
    }[locale];
    const productId3 = {
        eu: '9604647747927',
        uk: '9430789095763',
        de: '9535539315023',
        fr: '9432019370331',
        it: '9760871121245',
        es: '9432041029979',
    }[locale];
    return [
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463061/black.png',
                    productId: productId1,
                    variantId: (() => {
                        const id = {
                            eu: '50740963475799',
                            uk: '51053411107155',
                            de: '56082576441725',
                            fr: '50630586204507',
                            it: '55141750342008',
                            es: '50630616285531',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#212121',
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464726/white.png',
                    productId: productId1,
                    variantId: (() => {
                        const id = {
                            eu: '50740963508567',
                            uk: '51053411139923',
                            de: '56082576474493',
                            fr: '50630586237275',
                            it: '55141750374776',
                            es: '50630616318299',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#e2e2df',
                    name: 'white',
                },
            ],
        },
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463227/black2.png',
                    productId: productId2,
                    variantId: (() => {
                        const id = {
                            eu: '50740965605719',
                            uk: '51053411860819',
                            de: '56082582045053',
                            fr: '50630586663259',
                            it: '55141752439160',
                            es: '50630617629019',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#212121',
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464925/white2.png',
                    productId: productId2,
                    variantId: (() => {
                        const id = {
                            eu: '50740965638487',
                            uk: '51053411893587',
                            de: '56082582077821',
                            fr: '50630586696027',
                            it: '55141752471928',
                            es: '50630617661787',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#e2e2df',
                    name: 'white',
                },
            ],
        },
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573021/50-black.png',
                    color: '#212121',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            eu: '49178411270487',
                            uk: '49700418093395',
                            de: '49966509588815',
                            fr: '48933508219227',
                            it: '54413549306205',
                            es: '49343927157083',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748679704700/1.png',
                    color: '#cdcdcd',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            eu: '49178411303255',
                            uk: '49700418027859',
                            de: '49966509523279',
                            fr: '48933508251995',
                            it: '54413549240669',
                            es: '49343927091547',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    name: 'silver',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573309/50-blue.png',
                    color: '#c0defe',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            eu: '49178411336023',
                            uk: '49700418060627',
                            de: '49966509556047',
                            fr: '48933508284763',
                            it: '54413549273437',
                            es: '49343927124315',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    name: 'blue',
                },
            ],
        },
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573544/100-black.png',
                    color: '#212121',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            eu: '49178411368791',
                            uk: '49700418191699',
                            de: '49966509687119',
                            fr: '48933508317531',
                            it: '54413549404509',
                            es: '49343927255387',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748679704863/2.png',
                    color: '#cdcdcd',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            eu: '49178411401559',
                            uk: '49700418126163',
                            de: '49966509621583',
                            fr: '48933508350299',
                            it: '54413549338973',
                            es: '49343927189851',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    name: 'silver',
                },
            ],
        },
    ];
};

const getUsData = (locale = 'us') => {
    const productId1 = {
        us: '15361642856521',
        ca: '15126377234803',
    }[locale];
    const productId2 = {
        us: '15361644593225',
        ca: '15126380118387',
    }[locale];
    const productId3 = {
        us: '7302855557193',
        ca: '8339992051866',
    }[locale];
    const productId4 = {
        us: '7395983294537',
        ca: '15040389579123',
    }[locale];
    return [
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463061/black.png',
                    productId: productId1,
                    variantId: (() => {
                        const id = {
                            us: '54593882488905',
                            ca: '52731645460851',
                        };
                        return id[locale as 'us'] || id.eu;
                    })(),
                    color: '#212121',
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464726/white.png',
                    productId: productId1,
                    variantId: (() => {
                        const id = {
                            us: '54593882685513',
                            ca: '52731645493619',
                        };
                        return id[locale as 'us'] || id.eu;
                    })(),
                    color: '#e2e2df',
                    name: 'white',
                },
            ],
        },
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463227/black2.png',
                    productId: productId2,
                    variantId: (() => {
                        const id = {
                            us: '54593884651593',
                            ca: '52731646476659',
                        };
                        return id[locale as 'us'] || id.eu;
                    })(),
                    color: '#212121',
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464925/white2.png',
                    productId: productId2,
                    variantId: (() => {
                        const id = {
                            us: '54593884684361',
                            ca: '52731646509427',
                        };
                        return id[locale as 'us'] || id.eu;
                    })(),
                    color: '#e2e2df',
                    name: 'white',
                },
            ],
        },
        {
            children: [
                locale === 'us' && {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573021/50-black.png',
                    color: '#212121',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            us: '54347781832777',
                            ca: '',
                        };
                        return id[locale as 'us'] || id.eu;
                    })(),
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748679704700/1.png',
                    color: '#cdcdcd',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            us: '41843266584649',
                            ca: '45181875421338',
                        };
                        return id[locale as 'us'] || id.eu;
                    })(),
                    name: 'silver',
                },
                locale === 'us' && {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573309/50-blue.png',
                    color: '#c0defe',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            us: '42105281577033',
                            ca: '',
                        };
                        return id[locale as 'us'] || id.eu;
                    })(),
                    name: 'blue',
                },
            ].filter(Boolean),
        },
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748679704863/2.png',
                    color: '#cdcdcd',
                    productId: productId4,
                    variantId: (() => {
                        const id = {
                            us: '54612044054601',
                            ca: '52359916388723',
                        };
                        return id[locale as 'us'] || id.eu;
                    })(),
                    name: 'silver',
                },
            ],
        },
    ];
};

export default {
    jp: JP_Data,
    eu: getEuData('eu'),
    uk: getEuData('uk'),
    de: getEuData('de'),
    fr: getEuData('fr'),
    it: getEuData('it'),
    es: getEuData('es'),
    us: getUsData('us'),
    ca: getUsData('ca'),
};
